import Vue from 'vue';

const DistanceUtils = {

    POST(distance){
        return Vue.axios.put(`distance`, distance);
    },
    async createOrUpdateDistance(distance) {
        let newDistance = (await this.POST(distance)).data;
        console.log('newDistance: ' + JSON.stringify(newDistance));
        return newDistance;
    }

};

export default DistanceUtils;
